import { getFirebaseAuth } from "@/lib/firebase";

const LEGACY_COOKIE_NAME = "ps-session";

/**
 * Ask Firebase for the current token instead of duplicating it into a
 * JavaScript-readable cookie. Firebase refreshes an expired token as needed.
 */
export async function getSessionToken(): Promise<string | null> {
  return (await getFirebaseAuth().currentUser?.getIdToken()) ?? null;
}

/** Remove the token cookie written by versions deployed before this change. */
export function clearLegacySessionCookie() {
  document.cookie = `${LEGACY_COOKIE_NAME}=; path=/; max-age=0; samesite=lax`;
}
